import { render, staticRenderFns } from "./Change_Password.vue?vue&type=template&id=2e769028&scoped=true&"
import script from "./Change_Password.vue?vue&type=script&lang=js&"
export * from "./Change_Password.vue?vue&type=script&lang=js&"
import style0 from "./Change_Password.vue?vue&type=style&index=0&id=2e769028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e769028",
  null
  
)

export default component.exports